import { useMemo } from 'react';

import { IModules, IPages } from '~/lib/data-contract';
import { NegativeGap } from '~/templates/pages/components/NegativeGap/NegativeGap';

import { DynamicBlock } from '../DynamicBlock/DynamicBlock';

type Props = {
	pageType?: IPages['type'];
	elements: IModules[];
};

export const DynamicBlockList = ({ elements, pageType }: Props) => {
	const isSpecialProductDetail = useMemo(() => {
		const isProductDetail = pageType === 'p50ProductDetailPage';
		const isRenderingProductSpecs = elements.findIndex((el) => el.type === 'm550ProductSpecsModule');

		return Boolean(isProductDetail && isRenderingProductSpecs > -1);
	}, [pageType, elements]);

	if (!elements.length) {
		return null;
	}

	return (
		<>
			{elements.map((element, i) => {
				if (element.noSpaceAbove && i !== 0) {
					return (
						<NegativeGap key={element.id}>
							<DynamicBlock
								key={element.id}
								isSpecialProductDetail={isSpecialProductDetail}
								{...element}
							/>
						</NegativeGap>
					);
				} else {
					return (
						<DynamicBlock
							key={element.id}
							isSpecialProductDetail={isSpecialProductDetail}
							{...element}
						/>
					);
				}
			})}
		</>
	);
};
